import "./index.css";
import Voice from '../voice';

function VoiceHolder({ voices, deleteVoice, handleEditVoice }) {
  return <div className='voice-holder'>
{voices.map((voice, index) => (
  <Voice
    key={voice.id || voice.name}
    name={voice.name}
    color={voice.color}
    persona={voice.persona}
    icp={voice.icp}
    linkedinStatus={voice.linkedinStatus}
    linkedinEmail={voice.linkedinEmail}
    deleteVoice={() => deleteVoice(voice.id)}
    handleEditVoice={() => handleEditVoice(voice)}
    isDeletable={index !== 0}
  />
))}

    </div>
}

export default VoiceHolder;
